<ada-inline-menu
	ada-background-color="background"
	class="ada-history-detail-menu ada-color-background ada-sticky-top ada-border-inner-bottom ada-zindex-1"
	[controller]="menuController"
	[data]="node()"
	[textColor]="menuTextColor()"
/>
<ada-chat
	class="ada-history-detail-chat"
	[isFooterVisible]="false"
	[messages]="nodeMessages()"
/>
